module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_135251-46339794.4be6abea.jpg";